<template>
    <div class="row child-component">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
            <div class="d-block row col-lg-8 mx-auto">
                <div class="fieldborder">
                    <label>Employee Phone Number </label>
                    <the-mask type="text" @focus="ResetDirty('Phone')" @blur="SetDirty('Phone')"
                        :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', FormatPhoneNumber]" style="margin-top:1px;"
                        class="form-control" autocomplete="off" :maxlength="24" v-model="ProdExpVendor.Phone"
                        placeholder="Employee Phone Number"></the-mask>
                </div>
                <div class="fieldborder" style="margin-top: -22px;">
                    <label>ENTITY </label>
                    <OmniSelect class="" placeholder="Select Entity" name="Entity"
                    :showLabel="false" label="value" v-model="ProdExpVendor.Entity" :options="EntityList"></OmniSelect>
                </div>
                <div class="fieldborder" style="margin-top: -22px;">
                    <label>AGENCY </label>
                    <OmniSelect placeholder="Select Agency" name="Media" :showLabel="false" label="Select Media"
                        :options="AgencyList" v-model="ProdExpVendor.EmployeeAgency" />
                </div>

                <div class="fieldborder" style="margin-top: -22px;">
                    <b-form-group label="" class="timeonly-text">
                        <label>REQUEST TYPE </label>
                        <b-form-radio-group style="margin-left:10px;" class="omniipclass" id="time-only"
                            v-model="ProdExpVendor.RequestType" name="time-only">
                            <b-form-radio value="production">PRODUCTION</b-form-radio>
                            <b-form-radio value="expense">EXPENSE</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>

        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button v-if="IsDraftVisible" :disabled="!IsFormFilled" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
                SAVE FOR LATER
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>
    </div>
</template>

<style scoped>
.error-message {
    padding-top: 10px;
    padding-bottom: 5px;
    height: 14px !important;
    font-size: 12px !important;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #df5678 !important;
}

.floating-label-input {
    margin-top: 0px !important;
}

.fieldborder {
    padding-bottom: 30px !important;
}

.omniipclass {
    /* width: 415px !important; */
    height: 35px !important;
    border: #e9eef0 !important;
    /* style="width:415px; height:35px;" */
}

.Text {
    width: 250px;
    height: 196px;
    font-family: "Open Sans";
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
}

.Text .text-style-1 {
    font-weight: 600;
}
</style>

<script>
import { mapGetters } from "vuex";
import service from "../../../services/Dropdowns";
    import { required, minLength } from "vuelidate/lib/validators";
import { TheMask } from 'vue-the-mask';
import productionVendorSaveAsDraft from '../../../mixins/productionVendorSaveAsDraft.js';
export default {
    mixins: [productionVendorSaveAsDraft],
    data() {
        return {
            EntityList:[],
            AgencyList: [],
            validationtextbox: false,
            EditLoad: {
                EntityLoaded: false,
                AgencyLoaded: false,
            },
        }
    },
    components: {
        TheMask
    },
    validations: {
        ProdExpVendor: {
            Phone: {
                minLength: minLength(10),
            },
            Entity: {
                required
            },
            EmployeeAgency: {
                required
            },
            RequestType: {
                required
            }
        }
    },
    mounted() {
        this.LoadDropdownValues();
    },
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    watch: {
        "ProdExpVendor.EmployeeAgency": function (val) {
            let Agency = this.AgencyList.findIndex((item) => {
                return item.value == val;
            });
            if (Agency > -1) {
                this.ProdExpVendor.AgencyName = this.AgencyList[Agency].label;
            } else {
                this.ProdExpVendor.AgencyName = "";
            }
        },
        "ProdExpVendor.Entity": function (val) {
            let entity = this.EntityList.findIndex((item) => {
                return item.value == val;
            });
            if (entity > -1) {
                this.ProdExpVendor.EntityName = this.EntityList[entity].label;
            } else {
                this.ProdExpVendor.EntityName = "";
            }
            this.EntityChange();
        },
        "ProdExpVendor.Phone": function() {
            if (this.ProdExpVendor.Phone.length > 10) {
                this.FormatPhoneNumber = true;
            }
            else {
                this.FormatPhoneNumber = false;
            }
        },
        "ProdExpVendor.RequestType": function (val) {
            if (val == "production") {
                this.ProdExpVendor.ProductService = null;
                this.ProdExpVendor.DollarsAnticipatedToConductAnnuallyByVendor = null;
                this.$set(this.ProdExpVendor, "ServiceInfoFiles", []);
                if (this.$refs.myVueDropzone) {
                this.$refs.myVueDropzone.removeAllFiles(true);
                }
            }
        },
    },
    computed: {
        ...mapGetters('prodexpvendor', {
            ProdExpVendor: 'ProdExpVendor',
        }),
        IsDraftVisible: function () {
            return this.id == null || this.id == 0 || this.isDraft == true;
        },
        IsFormFilled() {
            return this.ProdExpVendor.RequestType !== null;
        },
        IsAgencyLoaded() {
            return this.EditLoad && this.EditLoad.AgencyLoaded;
        },
        IsEntityLoaded() {
            return this.EditLoad && this.EditLoad.EntityLoaded;
        },
        IsEdit() {
            return this.id && parseInt(this.id) > 0;
        },
        FormatPhoneNumber() {
            const infoFromPhone = this.ProdExpVendor.Phone || '';
            return infoFromPhone.length > 10 ? '####################' : '1-###-###-#####';
        },
    },
    methods: {
        AssignAgencyName() {
            let agency = this.AgencyList.findIndex((item) => {
                return item.value == this.ProdExpVendor.EmployeeAgency;
            });
            if (agency > -1) {
                this.ProdExpVendor.AgencyName = this.AgencyList[agency].label;
            } else {
                this.ProdExpVendor.AgencyName = "";
            }
        },
        async LoadAgencySelectedValue() {
            if (this.IsEdit) {
                this.$set(this.EditLoad, "AgencyLoaded", true);
                await this.AssignAgencyName();
            }
        },
        LoadEntitySelectedValue() {
            if (this.IsEdit) {
                this.$set(this.ProdExpVendor, "Entity", this.ProdExpVendor.Entity);
                const entity = this.EntityList.find(item => item.value == this.ProdExpVendor.Entity);
                this.ProdExpVendor.EntityName = entity ? entity.label : "";
                this.$set(this.EditLoad, "EntityLoaded", true);
            }
        },
        EntityChange() {
            var entityid = this.ProdExpVendor.Entity;
            service
                .getAgencyDropdownValues(entityid, entityid)
                .then((res) => {
                this.AgencyList = res.data;
                if (this.IsEdit && !this.IsAgencyLoaded) {
                    this.LoadAgencySelectedValue();
                } else {
                    if (res.data.length == 1) {
                        this.ProdExpVendor.EmployeeAgency = res.data[0].value;
                    } else {
                        this.ProdExpVendor.EmployeeAgency = null;
                    }
                }
                })
                .catch((err) => {
                    alert(err);
                });
            },
        async LoadDropdownValues() {
            service
            .getOriginalEntityRecords("Financial Entity")
            .then((res) => {
                this.EntityList = res.data;
                if (this.IsEdit && !this.IsEntityLoaded) {
                    this.LoadEntitySelectedValue();
                }
            })
            .catch((err) => {
                alert(err);
            });
        },
        Cancel() {
            this.$router.push("/VendorRequests");
        },
        SetDirty(property) {
            this.$v.ProdExpVendor[property].$touch();
        },
        ResetDirty(property) {
            this.$v.ProdExpVendor[property].$reset();
        },
        ValidateNumeric() {
            if (this.ProdExpVendor.Phone.length > 0) {
                this.validationtextbox = true;
            }
            else {
                this.validationtextbox = false;
            }
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Production Expense Vendor Attestation",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Production Expense Vendor Attestation",
                });
            }
        },
    },
}
</script>
